module.exports = __webpack_public_path__ + "img/parking-info-1@2x.9a98cbc2.png";